import React from 'react';
import { Outlet } from 'react-router-dom';

function ProfileBasePage() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default ProfileBasePage;
